// Team Admin i18n (prefix `admin.`) — layout, command palette, dashboard, review queue.
const en = {
  // sections + nav
  "admin.section.content": "Content",
  "admin.section.finance": "Finance",
  "admin.section.stats": "Statistics",
  "admin.section.campaigns": "Campaigns",
  "admin.section.communication": "Communication",
  "admin.nav.dashboard": "Dashboard",
  "admin.nav.reviewQueue": "Review Queue",
  "admin.nav.artists": "Artists",
  "admin.nav.content": "Content",
  "admin.nav.featureManager": "Feature Manager",
  "admin.nav.earnings": "Earnings",
  "admin.nav.payouts": "Payouts",
  "admin.nav.splits": "Revenue Splits",
  "admin.nav.payoutMethods": "Payout Methods",
  "admin.nav.subscriptions": "Subscriptions",
  "admin.nav.youtubeStats": "YouTube Stats",
  "admin.nav.spotifyStats": "Spotify Stats",
  "admin.nav.artistSpotify": "Artist Spotify",
  "admin.nav.viralCampaigns": "Viral Campaigns",
  "admin.nav.playlistCampaigns": "Playlist Applications",
  "admin.nav.playlists": "Playlists",
  "admin.nav.aiMatcher": "AI Matcher",
  "admin.nav.support": "Support",
  "admin.nav.announcements": "Announcements",
  "admin.nav.referrals": "Referrals",
  "admin.crumb.releaseDetail": "Release detail",
  "admin.crumb.ticketDetail": "Ticket",
  "admin.crumb.artistDetail": "Artist",
  "admin.role.super_admin": "Super Admin",
  "admin.role.support_team": "Support Team",
  "admin.role.content_review": "Content Review",
  "admin.role.finance_team": "Finance Team",
  // layout
  "admin.layout.panelTitle": "Admin Panel",
  "admin.layout.openMenu": "Open menu",
  "admin.layout.closeMenu": "Close menu",
  "admin.layout.collapseSidebar": "Collapse sidebar",
  "admin.layout.expandSidebar": "Expand sidebar",
  "admin.layout.lightMode": "Light mode",
  "admin.layout.darkMode": "Dark mode",
  "admin.layout.navigation": "Admin navigation",
  "admin.layout.breadcrumb": "Breadcrumb",
  "admin.layout.account": "Account menu",
  "admin.quick.pendingUsers": "Pending users",
  "admin.quick.pendingReleases": "Pending reviews",
  "admin.quick.payoutRequests": "Payout requests",
  "admin.quick.openTickets": "Open tickets",
  "admin.notif.title": "Notifications",
  "admin.notif.markAllRead": "Mark all read",
  "admin.notif.empty": "No notifications",
  "admin.notif.reason": "Reason",
  "admin.notif.fallbackTitle": "Notification",
  // palette
  "admin.palette.title": "Command palette",
  "admin.palette.open": "Open search (Ctrl+K)",
  "admin.palette.short": "Search…",
  "admin.palette.placeholder": "Search pages, artists, releases, UPC, ISRC…",
  "admin.palette.searching": "Searching…",
  "admin.palette.empty": "No results.",
  "admin.palette.pages": "Pages",
  "admin.palette.releases": "Releases",
  "admin.palette.artists": "Artists",
  "admin.palette.hint": "↑↓ to navigate · Enter to open",
  // statuses
  "admin.status.draft": "Draft",
  "admin.status.submitted": "Submitted",
  "admin.status.in_review": "In review",
  "admin.status.needs_edits": "Needs edits",
  "admin.status.approved": "Approved",
  "admin.status.rejected": "Rejected",
  "admin.status.live": "Live",
  "admin.status.taken_down": "Taken down",
  "admin.status.pending": "Pending",
  "admin.status.all": "All",
  // dashboard
  "admin.dash.title": "Operations",
  "admin.dash.subtitle": "What needs your attention right now.",
  "admin.dash.refresh": "Refresh",
  "admin.dash.updated": "Updated {time}",
  "admin.dash.kpi.pendingReviews": "Pending reviews",
  "admin.dash.kpi.openTickets": "Open tickets",
  "admin.dash.kpi.pendingPayouts": "Pending payouts",
  "admin.dash.kpi.pendingKyc": "Pending KYC",
  "admin.dash.kpi.newUsers7d": "New artists (7d)",
  "admin.dash.kpi.newUsers30d": "New artists (30d)",
  "admin.dash.kpi.totalArtists": "Total artists",
  "admin.dash.kpi.liveReleases": "Live releases",
  "admin.dash.kpi.pendingUsers": "Pending users",
  "admin.dash.kpi.avgReview": "Avg. review time",
  "admin.dash.kpi.oldestPending": "Oldest pending",
  "admin.dash.vsPrev": "vs previous period",
  "admin.dash.noData": "No data yet",
  "admin.dash.basedOn": "based on {n} decisions",
  "admin.dash.chart.reviewFlow": "Review flow · last 30 days",
  "admin.dash.chart.submissions": "Submissions",
  "admin.dash.chart.approvals": "Approvals",
  "admin.dash.chart.rejections": "Rejections",
  "admin.dash.chart.signups": "New artist signups · last 30 days",
  "admin.dash.chart.signupsLabel": "Signups",
  "admin.dash.chart.revenue": "Gross revenue · last 30 days",
  "admin.dash.chart.revenueLabel": "Revenue",
  "admin.dash.chart.emptyTitle": "Nothing recorded in the last 30 days",
  "admin.dash.attention.title": "Needs attention",
  "admin.dash.attention.reviews": "Oldest pending reviews",
  "admin.dash.attention.tickets": "Tickets waiting > 48h",
  "admin.dash.attention.payouts": "Payouts waiting",
  "admin.dash.attention.allClear": "All clear — nothing is waiting.",
  "admin.dash.attention.viewAll": "View all",
  "admin.dash.activity.title": "Recent activity",
  "admin.dash.activity.empty": "No admin activity recorded yet.",
  "admin.dash.activity.by": "by {name}",
  "admin.dash.error": "Couldn't load the dashboard.",
  "admin.dash.hours": "{n}h",
  "admin.dash.days": "{n}d",
  "admin.dash.minutes": "{n}m",
  // review queue
  "admin.rq.title": "Review Queue",
  "admin.rq.subtitle": "Oldest submissions first — keep the SLA green.",
  "admin.rq.searchPlaceholder": "Search title, artist, UPC, ISRC, email…",
  "admin.rq.sort.oldest": "Oldest first (SLA)",
  "admin.rq.sort.newest": "Newest first",
  "admin.rq.sort.priority": "Plan priority",
  "admin.rq.pendingAll": "All pending",
  "admin.rq.allStatuses": "All statuses",
  "admin.rq.submittedAgo": "Submitted {age} ago",
  "admin.rq.tracks": "{n} tracks",
  "admin.rq.track": "1 track",
  "admin.rq.explicit": "Explicit",
  "admin.rq.selected": "{n} selected",
  "admin.rq.selectAll": "Select all on page",
  "admin.rq.clear": "Clear",
  "admin.rq.bulkApprove": "Approve",
  "admin.rq.bulkEdits": "Request edits",
  "admin.rq.bulkReject": "Reject",
  "admin.rq.bulkConfirmApprove": "Approve {n} releases?",
  "admin.rq.bulkConfirmApproveDesc": "Each artist is notified by in-app notification and email, exactly like a single approval.",
  "admin.rq.reasonTitle": "Reason for {n} releases",
  "admin.rq.reasonTemplate": "Template",
  "admin.rq.reasonTemplatePlaceholder": "Pick a template (optional)",
  "admin.rq.reasonLabel": "Reason (sent to the artist)",
  "admin.rq.reasonRequired": "A reason is required.",
  "admin.rq.confirm": "Confirm",
  "admin.rq.cancel": "Cancel",
  "admin.rq.bulkDone": "{n} releases updated",
  "admin.rq.bulkPartial": "{ok} updated, {fail} failed",
  "admin.rq.bulkError": "Bulk update failed",
  "admin.rq.empty.title": "Queue is clear",
  "admin.rq.empty.desc": "No releases match these filters.",
  "admin.rq.empty.reset": "Reset filters",
  "admin.rq.error": "Couldn't load the review queue.",
  "admin.rq.play": "Play preview",
  "admin.rq.pause": "Pause preview",
  "admin.rq.noAudio": "No audio",
  "admin.rq.open": "Open",
  "admin.rq.pageOf": "Page {page} of {pages}",
  "admin.rq.prev": "Previous",
  "admin.rq.next": "Next",
  "admin.rq.total": "{n} releases",
  "admin.rq.sla.ok": "Within SLA",
  "admin.rq.sla.warn": "Approaching SLA",
  "admin.rq.sla.late": "SLA breached",
  "admin.rq.selectRelease": "Select release",
};

const tr = {
  "admin.section.content": "İçerik",
  "admin.section.finance": "Finans",
  "admin.section.stats": "İstatistikler",
  "admin.section.campaigns": "Kampanyalar",
  "admin.section.communication": "İletişim",
  "admin.nav.dashboard": "Panel",
  "admin.nav.reviewQueue": "İnceleme Kuyruğu",
  "admin.nav.artists": "Sanatçılar",
  "admin.nav.content": "İçerikler",
  "admin.nav.featureManager": "Özellik Yönetimi",
  "admin.nav.earnings": "Kazançlar",
  "admin.nav.payouts": "Ödemeler",
  "admin.nav.splits": "Gelir Paylaşımları",
  "admin.nav.payoutMethods": "Ödeme Yöntemleri",
  "admin.nav.subscriptions": "Abonelikler",
  "admin.nav.youtubeStats": "YouTube İstatistikleri",
  "admin.nav.spotifyStats": "Spotify İstatistikleri",
  "admin.nav.artistSpotify": "Sanatçı Spotify",
  "admin.nav.viralCampaigns": "Viral Kampanyalar",
  "admin.nav.playlistCampaigns": "Playlist Başvuruları",
  "admin.nav.playlists": "Playlistler",
  "admin.nav.aiMatcher": "AI Eşleştirici",
  "admin.nav.support": "Destek",
  "admin.nav.announcements": "Duyurular",
  "admin.nav.referrals": "Referanslar",
  "admin.crumb.releaseDetail": "Yayın detayı",
  "admin.crumb.ticketDetail": "Talep",
  "admin.crumb.artistDetail": "Sanatçı",
  "admin.role.super_admin": "Süper Admin",
  "admin.role.support_team": "Destek Ekibi",
  "admin.role.content_review": "İçerik İnceleme",
  "admin.role.finance_team": "Finans Ekibi",
  "admin.layout.panelTitle": "Yönetim Paneli",
  "admin.layout.openMenu": "Menüyü aç",
  "admin.layout.closeMenu": "Menüyü kapat",
  "admin.layout.collapseSidebar": "Kenar çubuğunu daralt",
  "admin.layout.expandSidebar": "Kenar çubuğunu genişlet",
  "admin.layout.lightMode": "Açık mod",
  "admin.layout.darkMode": "Koyu mod",
  "admin.layout.navigation": "Yönetim menüsü",
  "admin.layout.breadcrumb": "Gezinti yolu",
  "admin.layout.account": "Hesap menüsü",
  "admin.quick.pendingUsers": "Bekleyen kullanıcılar",
  "admin.quick.pendingReleases": "Bekleyen incelemeler",
  "admin.quick.payoutRequests": "Ödeme talepleri",
  "admin.quick.openTickets": "Açık talepler",
  "admin.notif.title": "Bildirimler",
  "admin.notif.markAllRead": "Tümünü okundu yap",
  "admin.notif.empty": "Bildirim yok",
  "admin.notif.reason": "Sebep",
  "admin.notif.fallbackTitle": "Bildirim",
  "admin.palette.title": "Komut paleti",
  "admin.palette.open": "Aramayı aç (Ctrl+K)",
  "admin.palette.short": "Ara…",
  "admin.palette.placeholder": "Sayfa, sanatçı, yayın, UPC, ISRC ara…",
  "admin.palette.searching": "Aranıyor…",
  "admin.palette.empty": "Sonuç yok.",
  "admin.palette.pages": "Sayfalar",
  "admin.palette.releases": "Yayınlar",
  "admin.palette.artists": "Sanatçılar",
  "admin.palette.hint": "↑↓ gezin · Enter ile aç",
  "admin.status.draft": "Taslak",
  "admin.status.submitted": "Gönderildi",
  "admin.status.in_review": "İncelemede",
  "admin.status.needs_edits": "Düzenleme gerekli",
  "admin.status.approved": "Onaylandı",
  "admin.status.rejected": "Reddedildi",
  "admin.status.live": "Yayında",
  "admin.status.taken_down": "Kaldırıldı",
  "admin.status.pending": "Bekliyor",
  "admin.status.all": "Tümü",
  "admin.dash.title": "Operasyon",
  "admin.dash.subtitle": "Şu anda ilgilenmen gerekenler.",
  "admin.dash.refresh": "Yenile",
  "admin.dash.updated": "{time} güncellendi",
  "admin.dash.kpi.pendingReviews": "Bekleyen incelemeler",
  "admin.dash.kpi.openTickets": "Açık talepler",
  "admin.dash.kpi.pendingPayouts": "Bekleyen ödemeler",
  "admin.dash.kpi.pendingKyc": "Bekleyen KYC",
  "admin.dash.kpi.newUsers7d": "Yeni sanatçı (7g)",
  "admin.dash.kpi.newUsers30d": "Yeni sanatçı (30g)",
  "admin.dash.kpi.totalArtists": "Toplam sanatçı",
  "admin.dash.kpi.liveReleases": "Yayındaki yayınlar",
  "admin.dash.kpi.pendingUsers": "Bekleyen kullanıcılar",
  "admin.dash.kpi.avgReview": "Ort. inceleme süresi",
  "admin.dash.kpi.oldestPending": "En eski bekleyen",
  "admin.dash.vsPrev": "önceki döneme göre",
  "admin.dash.noData": "Henüz veri yok",
  "admin.dash.basedOn": "{n} karara göre",
  "admin.dash.chart.reviewFlow": "İnceleme akışı · son 30 gün",
  "admin.dash.chart.submissions": "Gönderimler",
  "admin.dash.chart.approvals": "Onaylar",
  "admin.dash.chart.rejections": "Retler",
  "admin.dash.chart.signups": "Yeni sanatçı kayıtları · son 30 gün",
  "admin.dash.chart.signupsLabel": "Kayıtlar",
  "admin.dash.chart.revenue": "Brüt gelir · son 30 gün",
  "admin.dash.chart.revenueLabel": "Gelir",
  "admin.dash.chart.emptyTitle": "Son 30 günde kayıt yok",
  "admin.dash.attention.title": "İlgi bekleyenler",
  "admin.dash.attention.reviews": "En eski bekleyen incelemeler",
  "admin.dash.attention.tickets": "48 saatten uzun bekleyen talepler",
  "admin.dash.attention.payouts": "Bekleyen ödemeler",
  "admin.dash.attention.allClear": "Her şey yolunda — bekleyen bir şey yok.",
  "admin.dash.attention.viewAll": "Tümünü gör",
  "admin.dash.activity.title": "Son aktiviteler",
  "admin.dash.activity.empty": "Henüz kayıtlı yönetici aktivitesi yok.",
  "admin.dash.activity.by": "{name} tarafından",
  "admin.dash.error": "Panel yüklenemedi.",
  "admin.dash.hours": "{n}sa",
  "admin.dash.days": "{n}g",
  "admin.dash.minutes": "{n}dk",
  "admin.rq.title": "İnceleme Kuyruğu",
  "admin.rq.subtitle": "Önce en eski gönderimler — SLA'yı yeşilde tut.",
  "admin.rq.searchPlaceholder": "Başlık, sanatçı, UPC, ISRC, e-posta ara…",
  "admin.rq.sort.oldest": "Önce en eski (SLA)",
  "admin.rq.sort.newest": "Önce en yeni",
  "admin.rq.sort.priority": "Plan önceliği",
  "admin.rq.pendingAll": "Tüm bekleyenler",
  "admin.rq.allStatuses": "Tüm durumlar",
  "admin.rq.submittedAgo": "{age} önce gönderildi",
  "admin.rq.tracks": "{n} parça",
  "admin.rq.track": "1 parça",
  "admin.rq.explicit": "Müstehcen",
  "admin.rq.selected": "{n} seçildi",
  "admin.rq.selectAll": "Sayfadakilerin tümünü seç",
  "admin.rq.clear": "Temizle",
  "admin.rq.bulkApprove": "Onayla",
  "admin.rq.bulkEdits": "Düzenleme iste",
  "admin.rq.bulkReject": "Reddet",
  "admin.rq.bulkConfirmApprove": "{n} yayın onaylansın mı?",
  "admin.rq.bulkConfirmApproveDesc": "Her sanatçıya tekli onayda olduğu gibi uygulama içi bildirim ve e-posta gönderilir.",
  "admin.rq.reasonTitle": "{n} yayın için sebep",
  "admin.rq.reasonTemplate": "Şablon",
  "admin.rq.reasonTemplatePlaceholder": "Şablon seç (isteğe bağlı)",
  "admin.rq.reasonLabel": "Sebep (sanatçıya gönderilir)",
  "admin.rq.reasonRequired": "Sebep zorunludur.",
  "admin.rq.confirm": "Onayla",
  "admin.rq.cancel": "İptal",
  "admin.rq.bulkDone": "{n} yayın güncellendi",
  "admin.rq.bulkPartial": "{ok} güncellendi, {fail} başarısız",
  "admin.rq.bulkError": "Toplu güncelleme başarısız",
  "admin.rq.empty.title": "Kuyruk boş",
  "admin.rq.empty.desc": "Bu filtrelere uyan yayın yok.",
  "admin.rq.empty.reset": "Filtreleri sıfırla",
  "admin.rq.error": "İnceleme kuyruğu yüklenemedi.",
  "admin.rq.play": "Önizlemeyi oynat",
  "admin.rq.pause": "Önizlemeyi duraklat",
  "admin.rq.noAudio": "Ses yok",
  "admin.rq.open": "Aç",
  "admin.rq.pageOf": "Sayfa {page} / {pages}",
  "admin.rq.prev": "Önceki",
  "admin.rq.next": "Sonraki",
  "admin.rq.total": "{n} yayın",
  "admin.rq.sla.ok": "SLA içinde",
  "admin.rq.sla.warn": "SLA'ya yaklaşıyor",
  "admin.rq.sla.late": "SLA aşıldı",
  "admin.rq.selectRelease": "Yayını seç",
};

const es = {
  "admin.section.content": "Contenido",
  "admin.section.finance": "Finanzas",
  "admin.section.stats": "Estadísticas",
  "admin.section.campaigns": "Campañas",
  "admin.section.communication": "Comunicación",
  "admin.nav.dashboard": "Panel",
  "admin.nav.reviewQueue": "Cola de revisión",
  "admin.nav.artists": "Artistas",
  "admin.nav.content": "Contenidos",
  "admin.nav.featureManager": "Gestor de funciones",
  "admin.nav.earnings": "Ganancias",
  "admin.nav.payouts": "Pagos",
  "admin.nav.splits": "Reparto de ingresos",
  "admin.nav.payoutMethods": "Métodos de pago",
  "admin.nav.subscriptions": "Suscripciones",
  "admin.nav.youtubeStats": "Estadísticas de YouTube",
  "admin.nav.spotifyStats": "Estadísticas de Spotify",
  "admin.nav.artistSpotify": "Spotify de artistas",
  "admin.nav.viralCampaigns": "Campañas virales",
  "admin.nav.playlistCampaigns": "Solicitudes de playlist",
  "admin.nav.playlists": "Playlists",
  "admin.nav.aiMatcher": "AI Matcher",
  "admin.nav.support": "Soporte",
  "admin.nav.announcements": "Anuncios",
  "admin.nav.referrals": "Referidos",
  "admin.crumb.releaseDetail": "Detalle del lanzamiento",
  "admin.crumb.ticketDetail": "Ticket",
  "admin.crumb.artistDetail": "Artista",
  "admin.role.super_admin": "Super Admin",
  "admin.role.support_team": "Equipo de soporte",
  "admin.role.content_review": "Revisión de contenido",
  "admin.role.finance_team": "Equipo de finanzas",
  "admin.layout.panelTitle": "Panel de administración",
  "admin.layout.openMenu": "Abrir menú",
  "admin.layout.closeMenu": "Cerrar menú",
  "admin.layout.collapseSidebar": "Contraer barra lateral",
  "admin.layout.expandSidebar": "Expandir barra lateral",
  "admin.layout.lightMode": "Modo claro",
  "admin.layout.darkMode": "Modo oscuro",
  "admin.layout.navigation": "Navegación de administración",
  "admin.layout.breadcrumb": "Ruta de navegación",
  "admin.layout.account": "Menú de cuenta",
  "admin.quick.pendingUsers": "Usuarios pendientes",
  "admin.quick.pendingReleases": "Revisiones pendientes",
  "admin.quick.payoutRequests": "Solicitudes de pago",
  "admin.quick.openTickets": "Tickets abiertos",
  "admin.notif.title": "Notificaciones",
  "admin.notif.markAllRead": "Marcar todo como leído",
  "admin.notif.empty": "Sin notificaciones",
  "admin.notif.reason": "Motivo",
  "admin.notif.fallbackTitle": "Notificación",
  "admin.palette.title": "Paleta de comandos",
  "admin.palette.open": "Abrir búsqueda (Ctrl+K)",
  "admin.palette.short": "Buscar…",
  "admin.palette.placeholder": "Buscar páginas, artistas, lanzamientos, UPC, ISRC…",
  "admin.palette.searching": "Buscando…",
  "admin.palette.empty": "Sin resultados.",
  "admin.palette.pages": "Páginas",
  "admin.palette.releases": "Lanzamientos",
  "admin.palette.artists": "Artistas",
  "admin.palette.hint": "↑↓ para navegar · Enter para abrir",
  "admin.status.draft": "Borrador",
  "admin.status.submitted": "Enviado",
  "admin.status.in_review": "En revisión",
  "admin.status.needs_edits": "Requiere cambios",
  "admin.status.approved": "Aprobado",
  "admin.status.rejected": "Rechazado",
  "admin.status.live": "Publicado",
  "admin.status.taken_down": "Retirado",
  "admin.status.pending": "Pendiente",
  "admin.status.all": "Todos",
  "admin.dash.title": "Operaciones",
  "admin.dash.subtitle": "Lo que necesita tu atención ahora mismo.",
  "admin.dash.refresh": "Actualizar",
  "admin.dash.updated": "Actualizado {time}",
  "admin.dash.kpi.pendingReviews": "Revisiones pendientes",
  "admin.dash.kpi.openTickets": "Tickets abiertos",
  "admin.dash.kpi.pendingPayouts": "Pagos pendientes",
  "admin.dash.kpi.pendingKyc": "KYC pendientes",
  "admin.dash.kpi.newUsers7d": "Nuevos artistas (7d)",
  "admin.dash.kpi.newUsers30d": "Nuevos artistas (30d)",
  "admin.dash.kpi.totalArtists": "Total de artistas",
  "admin.dash.kpi.liveReleases": "Lanzamientos publicados",
  "admin.dash.kpi.pendingUsers": "Usuarios pendientes",
  "admin.dash.kpi.avgReview": "Tiempo medio de revisión",
  "admin.dash.kpi.oldestPending": "Pendiente más antiguo",
  "admin.dash.vsPrev": "vs periodo anterior",
  "admin.dash.noData": "Aún no hay datos",
  "admin.dash.basedOn": "basado en {n} decisiones",
  "admin.dash.chart.reviewFlow": "Flujo de revisión · últimos 30 días",
  "admin.dash.chart.submissions": "Envíos",
  "admin.dash.chart.approvals": "Aprobaciones",
  "admin.dash.chart.rejections": "Rechazos",
  "admin.dash.chart.signups": "Nuevos registros de artistas · últimos 30 días",
  "admin.dash.chart.signupsLabel": "Registros",
  "admin.dash.chart.revenue": "Ingresos brutos · últimos 30 días",
  "admin.dash.chart.revenueLabel": "Ingresos",
  "admin.dash.chart.emptyTitle": "Nada registrado en los últimos 30 días",
  "admin.dash.attention.title": "Requiere atención",
  "admin.dash.attention.reviews": "Revisiones pendientes más antiguas",
  "admin.dash.attention.tickets": "Tickets esperando > 48h",
  "admin.dash.attention.payouts": "Pagos en espera",
  "admin.dash.attention.allClear": "Todo en orden — nada en espera.",
  "admin.dash.attention.viewAll": "Ver todo",
  "admin.dash.activity.title": "Actividad reciente",
  "admin.dash.activity.empty": "Aún no hay actividad de administración.",
  "admin.dash.activity.by": "por {name}",
  "admin.dash.error": "No se pudo cargar el panel.",
  "admin.dash.hours": "{n}h",
  "admin.dash.days": "{n}d",
  "admin.dash.minutes": "{n}m",
  "admin.rq.title": "Cola de revisión",
  "admin.rq.subtitle": "Primero los envíos más antiguos — mantén el SLA en verde.",
  "admin.rq.searchPlaceholder": "Buscar título, artista, UPC, ISRC, email…",
  "admin.rq.sort.oldest": "Más antiguos primero (SLA)",
  "admin.rq.sort.newest": "Más recientes primero",
  "admin.rq.sort.priority": "Prioridad por plan",
  "admin.rq.pendingAll": "Todos los pendientes",
  "admin.rq.allStatuses": "Todos los estados",
  "admin.rq.submittedAgo": "Enviado hace {age}",
  "admin.rq.tracks": "{n} pistas",
  "admin.rq.track": "1 pista",
  "admin.rq.explicit": "Explícito",
  "admin.rq.selected": "{n} seleccionados",
  "admin.rq.selectAll": "Seleccionar todos en la página",
  "admin.rq.clear": "Limpiar",
  "admin.rq.bulkApprove": "Aprobar",
  "admin.rq.bulkEdits": "Solicitar cambios",
  "admin.rq.bulkReject": "Rechazar",
  "admin.rq.bulkConfirmApprove": "¿Aprobar {n} lanzamientos?",
  "admin.rq.bulkConfirmApproveDesc": "Cada artista recibe una notificación y un email, igual que con una aprobación individual.",
  "admin.rq.reasonTitle": "Motivo para {n} lanzamientos",
  "admin.rq.reasonTemplate": "Plantilla",
  "admin.rq.reasonTemplatePlaceholder": "Elige una plantilla (opcional)",
  "admin.rq.reasonLabel": "Motivo (se envía al artista)",
  "admin.rq.reasonRequired": "El motivo es obligatorio.",
  "admin.rq.confirm": "Confirmar",
  "admin.rq.cancel": "Cancelar",
  "admin.rq.bulkDone": "{n} lanzamientos actualizados",
  "admin.rq.bulkPartial": "{ok} actualizados, {fail} fallidos",
  "admin.rq.bulkError": "La actualización masiva falló",
  "admin.rq.empty.title": "La cola está vacía",
  "admin.rq.empty.desc": "Ningún lanzamiento coincide con estos filtros.",
  "admin.rq.empty.reset": "Restablecer filtros",
  "admin.rq.error": "No se pudo cargar la cola de revisión.",
  "admin.rq.play": "Reproducir vista previa",
  "admin.rq.pause": "Pausar vista previa",
  "admin.rq.noAudio": "Sin audio",
  "admin.rq.open": "Abrir",
  "admin.rq.pageOf": "Página {page} de {pages}",
  "admin.rq.prev": "Anterior",
  "admin.rq.next": "Siguiente",
  "admin.rq.total": "{n} lanzamientos",
  "admin.rq.sla.ok": "Dentro del SLA",
  "admin.rq.sla.warn": "Cerca del SLA",
  "admin.rq.sla.late": "SLA superado",
  "admin.rq.selectRelease": "Seleccionar lanzamiento",
};

export default { en, tr, es };
